// Клетката „Настанена от" в „Дневник на резервациите".
//
// Име = авторът на първата поръчка по сметката. Без име:
// - настанена в момента (status "seated") → „Още няма поръчка";
// - приключила след настаняване → „Без поръчка" („още" би било невярно —
//   поръчка вече няма да има, напр. празната сметка е поета от друга резервация);
// - ненастанена → „—".
// Обяснението е видим текст, не `title` — подсказката не се показва при докосване
// на таблет, а колоната се вижда от таблет нагоре.

import { useTranslation } from "react-i18next";

import { EM_DASH } from "../../../../components/dataTable";
import type { ReservationJournalRow } from "../../../../api/reportsReservations";

type SeatedByPlaceholderKey = "rvSeatedByNoOrder" | "rvSeatedByNoOrderClosed";

/** Ключът на обяснението за празна клетка, или `null` → само „—". */
const seatedByPlaceholderKey = (
  row: Pick<ReservationJournalRow, "status" | "seated_at">,
): SeatedByPlaceholderKey | null => {
  if (row.seated_at === null) return null;
  return row.status === "seated" ? "rvSeatedByNoOrder" : "rvSeatedByNoOrderClosed";
};

interface SeatedByCellProps {
  row: ReservationJournalRow;
}

export const SeatedByCell = ({ row }: SeatedByCellProps) => {
  const { t } = useTranslation();
  const name = row.first_order_by_name;

  if (name) {
    return (
      <span className="block truncate text-[13px] font-medium text-ink">{name}</span>
    );
  }

  const placeholderKey = seatedByPlaceholderKey(row);
  if (placeholderKey === null) {
    return <span className="text-faint">{EM_DASH}</span>;
  }
  return (
    <span className="block truncate text-[12px] italic text-faint">
      {t(`reportsPage.${placeholderKey}`)}
    </span>
  );
};
